import React from 'react';
import cn from 'classnames';

import { Sidebar } from 'components/Sidebar';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

import styles from './MenuLayout.module.scss';

const MenuLayout = ({
  className,
  mainClassName,
  children,
}: {
  className: any;
  mainClassName: any;
  children: any;
}) => (
  <div className={cn(styles.layout, className)}>
    <div className={cn(styles.container, 'menu-layout-container')}>
      <Sidebar />
      <div className={styles.inner}>
        <div className={styles.topBar}>
          <LanguageSwitcher />
        </div>
        <div className={cn(styles.main, mainClassName)}>{children}</div>
      </div>
    </div>
  </div>
);

export default React.memo(MenuLayout) as any;
